import { Component, EventEmitter, Output } from '@angular/core';
import { BaseRegulatorySectionComponent } from '../../../common/base-regulatory-section/base-regulatory-section.component';
import { RegepInvoiceProcessType } from 'src/app/+regep/entities/enums/regepInvoiceProcessType';
import { ControlContainer, NgForm } from '@angular/forms';

@Component({
  selector: 'app-bank-account-details',
  templateUrl: './bank-account-details.component.html',
  styleUrls: ['./bank-account-details.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class BankAccountDetailsComponent extends BaseRegulatorySectionComponent {
  public readonly INVOICE_PROCESS_TYPES = RegepInvoiceProcessType;

  @Output() changeCommentText = new EventEmitter<string>();

  protected get sectionComment(): string {
    return this.regulatoryData.regulatory_data_sections_state?.bank_account_details_comment;
  }

  protected set sectionComment(value: string) {
    this.regulatoryData.regulatory_data_sections_state.bank_account_details_comment = value;
  }

  protected get sectionLocked(): boolean {
    return this.regulatoryData.regulatory_data_sections_state?.is_bank_account_details_locked;
  }

  protected set sectionLocked(value: boolean) {
    this.regulatoryData.regulatory_data_sections_state.is_bank_account_details_locked = value;
  }
}
